type ProfileCompletionState = {
  profiles?: readonly { key?: string; value?: string }[];
  profileMembers?: readonly { key?: string }[];
};

const basicProfileKeys = ['BirthDate', 'Gender', 'EducationLevel'];

export const getMissingRequiredProfileKeys = (userPrefs: ProfileCompletionState): string[] => {
  return basicProfileKeys.filter(key => !userPrefs.profiles?.some(profile => profile.key === key));
};
